declare var process: {
  env: {
    NODE_ENV: string;
    REACT_APP_ENV: string;
  };
};

export const IS_PROD = process.env.REACT_APP_ENV === "prod";
export const NODE_ENV = process.env.NODE_ENV;
export const REACT_APP_GOOGLE_CLIENT_ID = IS_PROD
  ? "669352062046-culinha9bjkf0sb8lre2lqgi2v76hjsi.apps.googleusercontent.com"
  : "669352062046-p8jrhojjtrd5ev5nko1ee639mviancs6.apps.googleusercontent.com";
export const REACT_APP__API_HOST = IS_PROD
  ? "https://api.prod.intranet.auto1.cloud"
  : "https://api.qa.intranet.auto1.cloud";

export const TAG_MANAGER = "GTM-TSCSBNP";
